"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HANDLE_ERROR_BY_HOST_EVENT = void 0;
// eslint-disable-next-line import/prefer-default-export
exports.HANDLE_ERROR_BY_HOST_EVENT = 'handle_error_by_host_event';
